module.exports = __webpack_public_path__ + "img/icon-googleAds.04970205.png";